<template>
	<!-- <div class="bg-gray-100 p-6">
      <div class="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h2 class="text-2xl font-bold mb-4">Quote Summary</h2>
        <div class="border-2 border-gray-300 p-4 mb-4 rounded">
          <p class="text-sm py-2 leading-relaxed text-center">
            You are buying 
            <span class="font-semibold">{{ selectedClientQuoteSummary?.product_details?.product_name || 'Product Name' }}</span> 
            <br/>
            from 
            <span class="font-semibold">{{ selectedClientQuoteSummary?.intermediary_details?.intermediary_name || 'Intermediary Name' }}</span>
          </p>
        </div>
        <ul class="space-y-2">
          <li class="flex justify-between">
            <span class="font-medium">Premium Amount</span>
            <span>{{ formatCurrency(selectedClientQuoteSummary?.premium_amount) || '5,000 Ksh' }}</span>
          </li>
          <li class="flex justify-between">
            <span class="font-medium">Additional Premium</span>
            <span>{{ formatCurrency(selectedClientQuoteSummary?.additional_premium) || '2,000 Ksh' }}</span>
          </li>
          <li class="flex justify-between">
            <span class="font-medium">Charges</span>
            <span>{{ formatCurrency(selectedClientQuoteSummary?.charges) || '20 Ksh' }}</span>
          </li>
        </ul>
        <div class="mt-4 border-t-2 border-gray-300 pt-2">
          <p class="text-xl font-bold text-right">
            Total: 
            <span class="text-green-600">{{ formatCurrency(calculateTotal()) || '7,500 Ksh' }}</span>
          </p>
        </div>
        <a 
          href="#payment" 
          class="mt-4 block text-center bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
          @click.prevent="proceedToPayment"
        >
          Proceed to Payment
        </a>
      </div>
    </div> -->

	<div class="bg-gray-100 p-6">
		<div class="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
			<h2 class="text-2xl font-bold mb-4">Summary</h2>
			<div class="border-2 border-gray-300 p-4 mb-4 rounded">
				<p class="text-sm py-2 leading-relaxed text-center">
					You are buying
					<span class="font-semibold">{{
						selectedClientQuoteSummary.product_details.product_name
					}}</span>
					<br />from
					<span class="font-semibold">Intermediary Name 3</span>
				</p>
			</div>
			<ul class="space-y-2">
				<li class="flex justify-between">
					<span class="font-medium">Premium Amount</span>
					<span
						>{{
							selectedClientQuoteSummary.totalPremiumAmount.toFixed(
								2,
							)
						}}
						Ksh</span
					>
				</li>
				<li class="flex justify-between">
					<span class="font-medium">Additional Premium</span>
					<span>2,000 Ksh</span>
				</li>
				<li class="flex justify-between">
					<span class="font-medium">Charges </span>
					<span
						>{{
							selectedClientQuoteSummary.totalCharges.toFixed(2)
						}}
						Ksh</span
					>
				</li>
				<!-- <li class="flex justify-between">
            <span class="font-medium">VAT</span>
            <span>30 Ksh</span>
        </li> -->
			</ul>
			<div class="mt-4 border-t-2 border-gray-300 pt-2">
				<p class="text-xl font-bold text-right">
					Total:
					<span class="text-green-600"
						>{{
							selectedClientQuoteSummary.totalPremiumAmount.toFixed(
								2,
							)
						}}
						Ksh</span
					>
				</p>
			</div>
			<div
				@click="proceedToPayment"
				class="mt-4 block text-center bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
			>
				Proceed to Payment
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import clientQuotations from '../rsc/stores/client-quotations';
import loginStore from '../../auth/rsc/stores/login.store';

export default {
	beforeCreate() {
		// Show loader before component is created
		this.$emit('loader:show', true);
	},
	beforeDestroy() {
		// Unregister the Vuex module to prevent memory leaks
		this.$store.unregisterModule('clientQuotations');
	},
	created() {
		// Register the Vuex module for client quotations
		utils.registerModule('clientQuotations', clientQuotations, this.$store);
		utils.registerModule('login', login, this.$store);
	},
	computed: {
		...mapGetters(['selectedClientQuoteSummary']),
	},
	data() {
		return {
			// Add any additional reactive data properties if needed
		};
	},
	methods: {
		...mapActions(['viewClientQuoteSummary', 'updateRedirectPath']),
		goToLogin() {
			console.log('logn redirect');
			this.$router.push({
				path: '/main',
			});
		},
		formatCurrency(amount) {
			if (!amount) return null;
			try {
				return new Intl.NumberFormat('en-KE', {
					style: 'currency',
					currency: 'KES',
				}).format(amount);
			} catch (error) {
				console.error('Currency formatting error:', error);
				return 'Invalid Amount';
			}
		},
		calculateTotal() {
			const summary = this.selectedClientQuoteSummary;
			if (!summary) return 0;
			const premium = summary.premium_amount || 0;
			const additional = summary.additional_premium || 0;
			const charges = summary.charges || 0;
			// const vat = summary.vat || 0; // Uncomment if VAT is needed
			return premium + additional + charges; // + vat;
		},
		async proceedToPayment() {
			try {
				console.log(
					'Proceeding to payment for quote:',
					this.selectedClientQuoteSummary,
				);
				// Store the redirect path in Vuex
				//this.$store.commit('updateRedirectPath', '/user/invoice');
				this.$store.dispatch('updateRedirectPath', '/user/invoice');

				console.log('THIS IS===', this.$store);

				this.goToLogin();
			} catch (err) {
				console.error('Payment initiation failed:', err);
				this.$notify({
					type: 'error',
					title: 'Payment Error',
					text: 'Failed to proceed to payment',
					duration: 10000,
				});
			}
		},
	},
	async mounted() {
		try {
			await this.viewClientQuoteSummary({
				system_quotation_ref: 'qt-8d1yhhz50rmb52qb3h',
			});
			console.log('Quote summary fetched successfully');
			this.$emit('loader:show', false);
		} catch (err) {
			console.error('Failed to fetch quote summary:', err);
			this.$emit('loader:show', false);
			this.$notify({
				type: 'error',
				title: 'Fetch Error',
				text: 'Failed to load quote summary',
				duration: 10000,
			});
		}
	},
};
</script>

<style lang="less" scoped>
/* Existing styles from the second script, adapted for this component */
.quotation-card {
	border-radius: 10px;
	padding: 20px;
	background: #fff; /* Added for better visibility, adjust as needed */
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: subtle shadow for card effect */
}
</style>
